import React, { ReactNode } from 'react';

interface SectionMessageProps {
  children: ReactNode;
}

const SectionMessage: React.FC<SectionMessageProps> = ({ children }) => {
  return (
      <div className="mx-auto max-w-screen-2xl space-y-4">
        {children}
      </div>
  );
};

export default SectionMessage;
